import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { ArrowRight, Lock, ShieldCheck, User } from 'lucide-react';
import AvatarPlaceholder from '../AvatarPlaceholder';
import { useFailedImages } from '../../hooks/useFailedImages';
import './ProfilesSection.css';
import './FeaturedMatches.css';

const API = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const ageOf = dob => {
    if (!dob) return null;
    const years = Math.floor((Date.now() - new Date(dob).getTime()) / 31557600000);
    return years > 17 && years < 100 ? years : null;
};
const firstName = profile => String(profile?.name || '').trim().split(/\s+/)[0] || 'Member';

// Same layout and styling members see, for visitors: real photos from verified members, blurred and
// locked until they register (the server only sends photo, first name and date of birth for these).
const GuestFeatured = ({ onRegisterClick }) => {
    const [profiles, setProfiles] = useState([]);
    const [failedImages, markImageFailed] = useFailedImages();

    useEffect(() => {
        axios.get(`${API}/api/profiles/public-preview`)
            .then(res => setProfiles(res.data.profiles || []))
            .catch(() => setProfiles([]));
    }, []);

    // Two rows of four: always eight cards, padded with placeholders while the list loads or is short.
    const cards = Array.from({ length: 8 }, (_, index) => profiles[index] || { _id: `placeholder-${index}` });

    return (
        <section className="home-profiles fm-section">
            <div className="fm-inner">
                <div className="fm-header">
                    <div className="fm-heading">
                        <p className="fm-eyebrow">Featured Matches</p>
                        <h2>Meet Someone Who Shares <em>What Matters</em></h2>
                    </div>
                    <div className="fm-controls">
                        <button type="button" className="fm-viewall" onClick={onRegisterClick}>
                            View All Profiles <ArrowRight size={14} />
                        </button>
                    </div>
                </div>

                <div className="fm-track fm-track--wrap">
                    {cards.map(profile => {
                        const hasPhoto = profile.photo && !failedImages.has(profile.photo);
                        const age = ageOf(profile.dateOfBirth);
                        return (
                            <article key={profile._id} className="fm-card">
                                <div className="fm-photo" onClick={onRegisterClick} role="button" tabIndex={0} aria-label="Register to view this profile"
                                    onKeyDown={event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); onRegisterClick?.(); } }}>
                                    {hasPhoto ? (
                                        <img src={`${API}${profile.photo}`} alt="Verified member" style={{ filter: 'blur(9px)', transform: 'scale(1.12)' }} onError={() => markImageFailed(profile.photo)} />
                                    ) : (
                                        <span className="fm-avatar"><AvatarPlaceholder gender={profile.gender} size={150} variant="card" /></span>
                                    )}
                                </div>
                                <div className="fm-lock"><Lock size={20} color="#fff" /></div>
                                <div className="fm-body">
                                    <h3 onClick={onRegisterClick}>{profile.name ? firstName(profile) : 'Verified member'}</h3>
                                    <ul>
                                        {age && <li><User size={12} /> {age} Years</li>}
                                        <li><ShieldCheck size={12} /> Verified profile</li>
                                        <li><Lock size={12} /> Register to see details</li>
                                    </ul>
                                    <div className="fm-actions">
                                        <button type="button" className="fm-view" onClick={onRegisterClick}>View Profile <ArrowRight size={14} /></button>
                                    </div>
                                </div>
                            </article>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default GuestFeatured;
